<script>
  import Range from "./helpers/RangeVariable.svelte";
  import viewport from "../stores/viewport.js";
  import { progress, categoryIndex } from "../stores/global.js";
  import { getContext } from "svelte";

  const { categories } = getContext("App");
  const names = categories.map((d) => d.name);
  const ticks = categories.map(({ name, offset }) => ({ name, offset }));
  ticks.reverse();

  let value;
  let label;

  $: width = Math.floor($viewport.height * 0.75);
  $: $progress = 1 - value;
  $: $categoryIndex = names.indexOf(label);
  $: progressMobile = Math.min(0.85, $progress);
</script>

<div id="progress" style="width: {width}px;">
  <Range
    width="{width}"
    ticks="{ticks}"
    orientation="vertical"
    override="{1 - $progress}"
    bind:value
    bind:label
  />
</div>

<div id="progress-mobile">
  <span style="height: {100 - $progress * 100}%;"></span>
  <p style="top: {progressMobile * 100}%;">{label}</p>
</div>

<style>
  #progress {
    position: absolute;
    top: 90%;
    left: 100%;
    transform-origin: 0 0;
    transform: rotate(-90deg) translate(0, -2.5em);
  }

  #progress-mobile {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }

  #progress-mobile p {
    margin: 0;
    position: absolute;
    right: 0;
    font-size: 12px;
    text-transform: uppercase;
    transform-origin: 100% 50%;
    transform: rotate(-90deg) translate(0, -100%);
    white-space: nowrap;
  }

  #progress-mobile span {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 4px;
    background: var(--theme);
  }

  @media only screen and (max-width: 1024px) {
    #progress {
      top: 80%;
    }
  }

  @media only screen and (max-width: 640px) {
    #progress {
      display: none;
    }

    #progress-mobile {
      display: block;
    }
  }
</style>
